<template>
  <div class="sb-modal-content">
    <slot />
  </div>
</template>
